import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import InputGroup from "react-bootstrap/InputGroup";
import Stack from "react-bootstrap/Stack";
import { useApi, createAPIPOSTPayload } from "../auth";
import { backend_url } from "../constants";
import { useNavigate } from "react-router";
import { toast } from 'react-toastify';

function ParameterInput() {
  const [smiles, setSmiles] = useState("");
  const [showSettings, setShowSettings] = useState(false);
  const [species, setSpecies] = useState("Rat");
  const [strain, setStrain] = useState("Sprague-Dawley");
  const [sex, setSex] = useState("F");
  const [adminRoute, setAdminRoute] = useState("Feed");
  const [doseUnit, setDoseUnit] = useState("ppm");
  const [durationLabel, setDurationLabel] = useState("chronic");
  const [submitted, setSubmitted] = useState(false);
  const allowed_routes = [
    "Topical",
    "Feeding needles",
    "Subcutaneous",
    "Intraperitoneal",
    "Dermal",
    "Inhalation",
    "Capsule",
    "Intramuscular",
    "Drinking water",
    "Feed",
    "Intravenous",
    "Gavage",
  ];
  const strain_map = {
    Rat: ["Sprague-Dawley", "Fischer 344", "Wistar"],
    Mouse: ["CD-1", "B6C3F1", "Swiss"],
  };
  const navigate = useNavigate();
  function setValsFromParameters(params) {
    setSpecies(params.species);
    setStrain(params.strain);
    setSex(params.sex);
    setAdminRoute(params.adminRoute);
    setDoseUnit(params.doseUnit);
    setDurationLabel(params.durationLabel);
  }
  const { apiFetch } = useApi();
  useEffect(() => {
    apiFetch(backend_url + "/api/get-default-settings/")
      .then((res) => res.json())
      .then((data) => {
        setValsFromParameters(data);
      });
  }, []);

  function setDefaultSettings() {
    const settings = {
      species: species,
      strain: strain,
      sex: sex,
      adminRoute: adminRoute,
      doseUnit: doseUnit,
      durationLabel: durationLabel,
    };
    const payload = createAPIPOSTPayload({ settings: settings });
    apiFetch(backend_url + "/api/set-default-settings/", payload).then((res) =>
      console.log("settings saved")
    );
  }

  function createDTRun() {
    const settings = {
      smiles: smiles,
      species: species,
      strain: strain,
      sex: sex,
      adminRoute: adminRoute,
      doseUnit: doseUnit,
      durationLabel: durationLabel,
    };
    const payload = createAPIPOSTPayload({ settings: settings });
    apiFetch(backend_url + "/api/create-dt-run/", payload).then((res) =>
      res.json().then((json) => {
        if(res.status==200){
          navigate(`/result/${json.uuid}`);
        }
        else{
          toast.error(json);
          setSubmitted(false);
        }
      })
    );
  }
  return (
    <div className="floating-modal" style={{ minWidth: "30vw" }}>
      <div>
        <b>Enter Chemical Structure (SMILES)</b>
        <Form>
          <Form.Group
            className="mb-3"
            controlId="formSmiles"
            style={{ display: "flex", flexDirection: "row", margin: "1rem" }}
          >
            <InputGroup className="icon-input">
              <span
                className="material-symbols-rounded input-icon"
                style={{
                  fontVariationSettings:
                    "'FILL' 1, 'wght' 300, 'GRAD' 0, 'opsz' 24",
                }}
              >
                science
              </span>
              <Form.Control
                type="text"
                placeholder="e.g. O=C(C)Oc1ccccc1C(=O)O"
                value={smiles}
                onChange={(e) => setSmiles(e.target.value)}
                className="input-with-icon"
              />
            </InputGroup>
            <Button
              onClick={(e) => {
                setSubmitted(true);
                createDTRun();
                e.preventDefault();
              }}
              disabled={!smiles || submitted}
              className="dt-button"
              variant="primary"
              type="submit"
              style={{ width: "10rem" }}
            >
              {submitted ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : null}
              Predict
            </Button>
          </Form.Group>
        </Form>
        <Stack gap={2} style={{ alignItems: "center" }}>
          <div className="description-text">TRY SAMPLE CHEMICALS</div>
          <Stack
            direction="horizontal"
            style={{ justifyContent: "center" }}
            gap={3}
          >
            <Button
              variant="light"
              onClick={(e) => setSmiles("O=C(C)Oc1ccccc1C(=O)O")}
            >
              Aspirin
            </Button>
            <Button
              variant="light"
              onClick={(e) => setSmiles("c1c2ccccc2ccc1")}
            >
              Naphthalene
            </Button>
            <Button
              variant="light"
              onClick={(e) => setSmiles("CN1C=NC2=C1C(=O)N(C(=O)N2C)C")}
            >
              Caffeine
            </Button>
          </Stack>
          {showSettings ? (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShowSettings(false);
              }}
              style={{ alignSelf: "start", marginBottom: "2rem" }}
            >
              Hide Settings
            </a>
          ) : (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShowSettings(true);
              }}
              style={{ alignSelf: "start" }}
            >
              Show Advanced Settings
            </a>
          )}
        </Stack>
        <div
          className={
            showSettings ? "advanced-settings show" : "advanced-settings"
          }
        >
          <Form>
            <Form.Group controlId="animalForm.SpeciesInput">
              <Form.Label>
                <b>Species</b>
              </Form.Label>
              <Form.Select
                type="text"
                value={species}
                onChange={(e) => setSpecies(e.target.value)}
              >
                <option value="Rat">Rat</option>
                <option value="Mouse">Mouse</option>
              </Form.Select>
            </Form.Group>
            <Form.Group controlId="animalForm.StrainInput">
              <Form.Label>
                <b>Strain</b>
              </Form.Label>
              <Form.Select
                type="text"
                value={strain}
                onChange={(e) => setStrain(e.target.value)}
              >
                {strain_map[species]?.map((strain) => (
                  <option value={strain}>{strain}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group controlId="animalForm.SexInput">
              <Form.Label>
                <b>Sex</b>
              </Form.Label>
              <Form.Select
                type="text"
                value={sex}
                onChange={(e) => setSex(e.target.value)}
              >
                <option value="M">Male</option>
                <option value="F">Female</option>
                <option value="B">Both</option>
              </Form.Select>
            </Form.Group>
            <Form.Group controlId="adminForm.RouteInput">
              <Form.Label>
                <b>Administration Route</b>
              </Form.Label>
              <Form.Select
                type="text"
                value={adminRoute}
                onChange={(e) => setAdminRoute(e.target.value)}
              >
                {allowed_routes.map((route) => (
                  <option value={route}>{route}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group controlId="unitForm.UnitInput">
              <Form.Label>
                <b>Dose Unit</b>
              </Form.Label>
              <Form.Select
                type="text"
                value={doseUnit}
                onChange={(e) => setDoseUnit(e.target.value)}
              >
                <option value={"ppm"}>ppm</option>
                <option value={"mg/kg"}>mg/kg</option>
              </Form.Select>
            </Form.Group>
            <Form.Group controlId="unitForm.UnitInput">
              <Form.Label>
                <b>Duration</b>
              </Form.Label>
              <Form.Select
                type="text"
                value={durationLabel}
                onChange={(e) => setDurationLabel(e.target.value)}
              >
                <option value={"acute"}>acute</option>
                <option value={"subchronic"}>subchronic</option>
                <option value={"chronic"}>chronic</option>
              </Form.Select>
            </Form.Group>
          </Form>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setDefaultSettings();
            }}
          >
            Make these my default settings
          </a>
        </div>
      </div>
    </div>
  );
}
export default ParameterInput;
